import { dm_cauhinhxebus } from '../../models/response/bus/dm_cauhinhxebus';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_CAU_HINH_XE_BUS_PATH = "cau-hinh-xe-bus";

class CauHinhXeBusApi extends BaseCRUDApi<dm_cauhinhxebus> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	SelectByCoSo(dm_coso_id: number) {
		return apiClient.get(`co-so/${dm_coso_id}/cau-hinh-xe-bus`);
	}
}
export const cauHinhXeBusApi = new CauHinhXeBusApi(API_CAU_HINH_XE_BUS_PATH);
